<base-index-page
    [config]="baseIndexPageConfig"
    [service]="qualityManagementService"
    [idKey]="'companyDocumentId'"
    [subSectionSettings]="'deleteCompanyDocument'"
></base-index-page>
 